export const cdnDomain = "https://cdn.turna.com/";
export const cdnCommonPath = `${cdnDomain}saka/common/`;
export const cdnCampaignsPath = `${cdnDomain}saka/campaigns/`;
export const cdnBusPath = `${cdnDomain}saka/bus/`;
export const cdnFlightPath = `${cdnDomain}saka/flight/`;
export const cdnFerryPath = `${cdnDomain}saka/ferry/`;
export const cdnCarPath = `${cdnDomain}saka/car/`;
export const cdnHotelPath = `${cdnDomain}saka/hotel/`;
export const cdnEmailPath = `${cdnDomain}saka/email/`;
export const cdnFlagsPath = `${cdnDomain}saka/flags/`;
export const cdnLandingPath = `${cdnDomain}saka/landing/`;
